import prebidInstance from "./prebidSetup";

/**
 * List of predefined ad units
 */
const adUnits = [
  {
    code: "navbar-ad",
    mediaTypes: { 
      banner: { 
        sizes: [[728, 90], [720, 90], [970, 250], [970, 90]] 
      } 
    },
    bids: 

    [
      {
        bidder: 'smartyads',
        params: {
          sourceid: '7311',
          host: 'prebid',
          accountid: '20524',
          traffic: 'banner'
        }
      },
      {
        bidder: 'bitmedia',
        params: {
            adUnitID: '67c8ce74aa72d3d47fd4cdd9',
            currency: 'USD'
        },
    }, 

    ]
  },
    {
    code: "banner-bottom",
    mediaTypes: { 
      banner: { 
        sizes: [[728, 90], [720, 90], [468, 60], [970, 250], [970, 90]] 
      } 
    },
    bids: 

    [
      {
        bidId: 'bidid',
        bidder: 'smartyads',
        params: {
            sourceid: '7397',
            host: 'prebid',
            accountid: '20524',
            traffic: 'banner'
        }
      }

    ]
  },
    {
    code: "sidebar-top", // Unique ID for sidebar ad
    mediaTypes: {
      banner: {
        sizes: [
          [300, 250], [320, 250], [300, 600], 
          [336, 280], [320, 480], [300, 1050] // Supports all requested sizes
        ]
      }
    },
    bids: 
    [
      {
        bidId: 'bidid',
        bidder: 'smartyads',
        params: {
            sourceid: '7356',
            host: 'prebid',
            accountid: '20524',
            traffic: 'banner'
        }
      },

      { 
        bidder: 'bitmedia', 
        params: { 
          adUnitID: '67ce526aaa72d3d47fe58e74', 
          currency: 'USD' 
        }, 
      }

    ]
  },

  {
    code: "inarticle-paragraph14",
    mediaTypes: {
      banner: {
        sizes: [
          [300, 250], [320, 480], [320, 250], 
          [336, 280], [468, 60], [240, 400] // Supports all requested sizes
        ]
      }
    },
    bids: 
    [
      {
        bidId: 'bidid',
        bidder: 'smartyads',
        params: {
            sourceid: '7357',
            host: 'prebid',
            accountid: '20524',
            traffic: 'banner'
        }
    }
    ]
  },

    {
    code: "inarticle-paragraph30",
    mediaTypes: {
      banner: {
        sizes: [
          [300, 250], [320, 480], [320, 250], 
          [336, 280], [468, 60], [240, 400] // Supports all requested sizes
        ]
      }
    },
    bids: 
    [
      {
        bidId: 'bidid',
        bidder: 'smartyads',
        params: {
            sourceid: '7396',
            host: 'prebid',
            accountid: '20524',
            traffic: 'banner'
        }
    }
    ]
  },

    {
  code: "navbar-mobile", // Unique ID for navbar ad
      mediaTypes: {
        banner: {
          sizes: [
            [320, 50], [320, 100], [300, 50], 
            [300, 100], [300, 250] // Supports all requested sizes
          ]
        }
      },

      bids: 
      [
      {
        bidId: 'bidid',
        bidder: 'smartyads',
        params: {
            sourceid: '7393',
            host: 'prebid',
            accountid: '20524',
            traffic: 'banner'
        }
    },
      { bidder: 'bitmedia', 
          params: { 
            adUnitID: '67d309ff0c84b453ac5609cb', 
            currency: 'USD' 
          }, 
      },
    ],
    },

    {
      code: "inarticle-paragraph3-mobile",
      mediaTypes: {
        banner: {
          sizes: [
            [320, 50], [320, 100], [300, 50], [300, 100], 
            [300, 250], [320, 250], [336, 280]
          ]
        }
      },
      bids: 
      [
      {
        bidId: 'bidid',
        bidder: 'smartyads',
        params: {
            sourceid: '7398',
            host: 'prebid',
            accountid: '20524',
            traffic: 'banner'
        }
    }
    ],
    },

        {
      code: "inarticle-paragraph14-mobile",
      mediaTypes: {
        banner: {
          sizes: [
            [320, 50], [320, 100], [300, 50], [300, 100], 
            [300, 250], [320, 250], [336, 280]
          ]
        }
      },
      bids: 
      [
      {
        bidId: 'bidid',
        bidder: 'smartyads',
        params: {
            sourceid: '7399',
            host: 'prebid',
            accountid: '20524',
            traffic: 'banner'
        }
    }
    ],
    },

    {
      code: "inarticle-paragraph30-mobile",
      mediaTypes: {
        banner: {
          sizes: [
            [320, 50], [320, 100], [300, 50], [300, 100], 
            [300, 250], [320, 250], [336, 280]
          ]
        }
      },
      bids: 
      [
      {
        bidId: 'bidid',
        bidder: 'smartyads',
        params: {
            sourceid: '7400',
            host: 'prebid',
            accountid: '20524',
            traffic: 'banner'
        }
    }
    ],
    },

    {
      code: "mobile-bottom",
      mediaTypes: {
        banner: {
          sizes: [
            [320, 50], [320, 100], [300, 50], [300, 100], [300, 250], 
            [320, 250], [336, 280], [320, 480], [468, 60], [240, 400]
          ]
        }
      },
      bids: 
      [
      {
        bidId: 'bidid',
        bidder: 'smartyads',
        params: {
            sourceid: '7401',
            host: 'prebid',
            accountid: '20524',
            traffic: 'banner'
        }
    }
    ],
    },




    {
    code: "native-ad-300x250", // Unique ID for the native ad unit
        mediaTypes: {
            native: {}
        },

    // Placement Type should be in "params", not inside "mediaTypes"
    bids: 
    [
      {
        bidId: 'bidid',
        bidder: 'smartyads',
        params: {
            sourceid: '7355',
            host: 'prebid',
            accountid: '20524',
            traffic: 'native',
            responseType: 'rtb'
        }
      },

    ]
  },

    {
    code: "outstream_in_article",
    mediaTypes: {
      video: {
        context: "outstream",
        playerSize: [[300, 250], [400, 300], [480, 320], [640, 360]],
        mimes: ["video/mp4", "video/webm"],
        protocols: [2, 5],
        linearity: 2,
        startdelay: 0,
        playbackmethod: [2, 5],
        api: [2]
      }
    },
    bids: 
    [

      {
        bidId: 'bidid',
        bidder: 'smartyads',
        params: {
            sourceid: '7341',
            host: 'prebid',
            accountid: '20524',
            traffic: 'video'
        }
      }
    ]
  }
];

/**
 * Registers ad units with Prebid.js and immediately resolves when done.
 */
/**
 * Registers ad units with Prebid.js and immediately resolves when done.
 */
const registerAdUnits = () => {
  return new Promise((resolve) => {
    const pbjs = window.pbjs || prebidInstance.pbjs; //Use PrebidInitializer instance

    if (typeof window === "undefined" || !pbjs?.que) {
      //console.warn("[registerAdUnits] Prebid.js is not available!");
      return resolve(false);
    }

    pbjs.que.push(() => {
      if (!pbjs.adUnits) pbjs.adUnits = [];

      //Use Set for efficient lookup of already registered ad units
      const registeredUnitCodes = new Set(pbjs.adUnits.map(unit => unit.code));

      //Filter only new ad units that haven't been registered yet
      const newAdUnits = adUnits.filter(adUnit => !registeredUnitCodes.has(adUnit.code));

      if (newAdUnits.length > 0) {
        pbjs.addAdUnits(newAdUnits);
      } else {
        //console.warn("[registerAdUnits] No new ad units to register.");
        return resolve(true);
      }

      //Verify all ad units are successfully registered
        const allRegistered = adUnits.every(adUnit =>
          pbjs.adUnits.some(unit => unit.code === adUnit.code)
        );

        if (allRegistered) {
          resolve(true);
        } else {
          //console.warn("[registerAdUnits] Some ad units may not be registered.");
          resolve(false);
        }
    });
  });
};

export { registerAdUnits, adUnits };
